export default __webpack_public_path__ + "static/corporate-table2-01-69fc201a518d63a5a95a0b46c879ed9a.png";